<template>
  <v-app-bar
    app
    color="transparent"
    flat
    height="64px"
  >
    <div class="d-flex align-center">
      <v-btn
        fab
        small
        class="custom-elevation-2 custom-border white-background"
        @click="$emit('close'); $router.back()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <v-spacer></v-spacer>

    <div class="d-flex align-center">
      <v-btn
        v-if="clue"
        rounded
        outlined
        class="custom-elevation-2 custom-border white-background"
        :title="$t('GAME.CLUE')"
        :disabled="!activeClue"
        @click="$emit('clue')"
      >
        {{ $t('GAME.CLUE') }}
      </v-btn>

      <div class="score py-2 mx-3">
        <!-- {{ currentScore }} -->
        <ScoreDrawer :score="currentScore" />
      </div>
    </div>
  </v-app-bar>
</template>

<style scoped>

.score {
  /*background: #f7dde1;*/
  /*color: #7F22FD;*/
  color: var(--v-primary-base);
  /*border-radius: 16px;*/
  /*font-weight: bold;*/
  /*width: 64px;*/
  text-align: center;
}
</style>

<script>
import ScoreDrawer from '@/components/navigation/ScoreDrawer.vue';

export default {
  name: 'MainTopbar',
  components: {
    ScoreDrawer,
  },
  props: {
    clue: {
      type: Boolean,
      default: true,
    },
    score: {
      type: [String, Number, Array],
      default: '',
    },
    activeClue: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    currentScore() {
      return this.score || this.$store.state.score.score || 0;
    },
  },
};
</script>
